import {
  CapaQuotationMaterial,
  CapaQuotationDetailedMaterialType,
  CapaQuotationChatRoomStatus,
  CapaQuotationPartnerStatus
} from '@generated/graphql';

export enum MoldTransferConditionEnum {
  'ON_DELIVERY' = 'onDelivery',
  'KEEP_AFTER_DELIVERY' = 'keepAfterDelivery',
  'NO_TRANSFER' = 'noTransfer'
}

export interface CreateOrderMutationInputItem {
  fileName: string;
  fileId?: string;
  quantity: number;
  cost?: number;
  material?: CapaQuotationMaterial | CapaQuotationDetailedMaterialType;
  etc?: string;
}

export enum InspectionOption {
  APPEARANCE = 'appearance',
  DIMENSION = 'dimension',
  FUNCTION = 'function',
  ETC = 'etc'
}

export const CLOSED_CHAT_ROOM_STATES: (
  | CapaQuotationChatRoomStatus
  | undefined
)[] = [
  CapaQuotationChatRoomStatus.ClosedBeforeConsulting,
  CapaQuotationChatRoomStatus.ClosedClient,
  CapaQuotationChatRoomStatus.ClosedConfirm,
  CapaQuotationChatRoomStatus.ClosedPartner
];

export const inactivatedPartnerStatus = [CapaQuotationPartnerStatus.Deleted];

type StringBoolean = 'true' | 'false';

export interface MobilePaymentRedirectQueryString {
  imp_uid?: string;
  merchant_uid?: string;
  imp_success?: StringBoolean;
  payment_redirect?: 'true';
  error_msg?: string;
  error_code?: string;
}
